import { AddIcon } from "@chakra-ui/icons";
import { Button, Spinner } from "@chakra-ui/react";
import React from "react";
interface Props {
  loading?: boolean;
  disabled?: boolean;
  handleClick: any;
  title: string;
  sx?: any;
  type?: "button" | "submit" | "reset" | undefined;
  leftIcon?: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg";
  width?: string;
  variant?: "brand" | "light";
  isLeftIcon?: boolean;
  isRightIcon?: boolean;
  rightIcon?: React.ReactNode;
}
const Index: React.FC<Props> = ({
  loading,
  disabled,
  handleClick,
  title,
  sx,
  type,
  leftIcon,
  size,
  width,
  variant,
  isLeftIcon,
  isRightIcon,
  rightIcon,
}) => {
  return (
    <>
      <Button
        fontSize="sm"
        variant={variant ? variant : "brand"}
        fontWeight="500"
        w={width ? width : "auto"}
        minW={width ? width : "160px"}
        mb="24px"
        onClick={handleClick}
        type={type ? type : "button"}
        isDisabled={disabled ? disabled : loading}
        leftIcon={
          isLeftIcon && React.isValidElement(leftIcon) ? leftIcon : undefined
        }
        rightIcon={
          isRightIcon && React.isValidElement(rightIcon) ? rightIcon : undefined
        }
        size={size ? size : "md"}
        px={"25px"}
        sx={sx}
      >
        {loading ? <Spinner size="xs" /> : <>{title}</>}
      </Button>
    </>
  );
};

export default Index;
